
<template>
  <div class="ma-3 text-xs-center">
    <h1 class="mt-3 mb-3">Artists</h1>
    <h3 style="font-size: 20pt">Grant Dersom</h3>
    <img
      class="artistImage"
      v-bind:src="require('../assets/profile-photo-small.jpg')"
    />

    <h1 class="mt-3 mb-3">Sheet Music</h1>
    <h4 class="mt-3 mb-3">Free Downloads</h4>
    (subject to change)
    <v-container class="pa-0 justify-center">
      <v-layout row wrap class="justify-center">
        <v-card
          style="float: left; border-color: black"
          v-for="infoItem in freeMusic()"
          v-bind:key="infoItem"
          class="ma-2 pa-2"
        >
          <FreeMusicItem :infoItem="infoItem"></FreeMusicItem>
        </v-card>
      </v-layout>
    </v-container>
    <v-divider class="mt-2 mb-5"></v-divider>
    <h3 class="mt-3 mb-3">Digital and Print</h3>
    <v-container class="pa-0 justify-center">
      <v-layout row wrap class="justify-center">
        <v-card
          style="float: left; border-color: black"
          v-for="book in print()"
          v-bind:key="book"
          class="ma-3 pa-2"
        >
          <MusicSelectionItem :book="book"></MusicSelectionItem>
        </v-card>
      </v-layout>
    </v-container>

    <v-divider class="mt-2 mb-5"></v-divider>
    <h3 style="display: inline" class="mt-5 mb-3">Audio Releases</h3>
    <v-container>
      <v-layout row wrap class="justify-center">
        <v-card
          style="float: left"
          v-for="book in audio()"
          v-bind:key="book"
          class="ma-3 pa-2"
        >
          <MusicSelectionItem :book="book"></MusicSelectionItem>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import music from "../data/music-data";
import { freeMusic } from "../data/free-downloads";
import MusicSelectionItem from "./MusicSelectionItem";
import FreeMusicItem from "./FreeMusicItem.vue";

export default {
  name: "MusicSelection",
  methods: {
    freeMusic() {
      return freeMusic;
    },
    print() {
      return music.Print;
    },
    audio() {
      return music.Audio;
    },
  },
  components: {
    MusicSelectionItem,
    FreeMusicItem,
  },
  data: () => ({}),
};
</script>

<style scoped>
.v-card {
  display: block;
  width: 300px;
  height: auto;
  overflow: auto;
}

.artistImage {
  max-width: 200px;
}
</style>